const autoNgTemplateLoaderTemplate1 = require('./template.html');

angular.module('shbdeployer.kubernetes').component('kubernetesVolumesStoragesDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesVolumesStoragesDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    refreshCallback: '<',
  },
});
